<template>
  <f7-page class="chat chat-history">
    <f7-navbar :title="`Lesson ${this.$f7route.params.id}`" back-link="Back"></f7-navbar>

    <span v-if="!messages.length" class="chat-empty-message">
      No messages
    </span>

    <f7-messages v-else ref="messages">
      <f7-message
        v-for="(message, index) in messages"
        :key="index"
        :type="message.type"
        :first="isFirstMessage(message, index)"
        :last="isLastMessage(message, index)"
        :tail="isTailMessage(message, index)"
        :class="{ 'with-mark': message.mark }"
      >
        <span v-if="message.text" slot="text" v-html="message.text"></span>

        <!-- <span v-if="message.isQuestion && message.answers" slot="default" class="question-button">
          <template v-for="(answer, index2) in message.answers">
            <f7-button v-if="answer.type === 'text'" :key="index2" fill large :active="false">
              {{ answer.text }}
            </f7-button>

            <img
              v-if="answer.type === 'image'"
              :key="index2"
              :src="`${BASE_PATH}/storage/${answer.image}`"
              alt="alt"
            />
          </template>
        </span> -->

        <!-- QUOTE TEMPLATE -->
        <span v-if="message.quote" slot="bubble-start" class="quote-messages">
          <img src="../static/quote-black.svg" alt="quote" />
          <div class="quote-messages-text">{{ message.quote }}</div>
          <div class="quote-messages-info">
            {{ format(new Date(message.quoteDate), 'd.L.yyyy, HH:mm:ss') }}
          </div>
        </span>

        <!-- MARK TEMPLATE -->
        <span v-if="message.mark" slot="bubble-end" class="message-mark-icon">
          {{ message.mark === 'like' ? '👍' : '👎' }}
        </span>

        <!-- IMAGE TEMPLATE -->
        <span v-if="message.attachment && message.attachment.type === 'image'" slot="image">
          <img
            :src="
              `${message.attachment.type === 'image_url' ? '' : BASE_PATH}${message.attachment.src}`
            "
            :alt="message.attachment.name"
            @click="openPhotoBrowser(message.attachment.src)"
          />
        </span>

        <span v-if="message.attachment && message.attachment.type === 'image_url'" slot="image">
          <img
            :src="message.attachment.src"
            :alt="message.attachment.name"
            @click="openPhotoBrowser(message.attachment.src)"
          />
        </span>

        <!-- AUDIO MESSAGE TEMPLATE -->
        <span v-if="message.attachment && message.attachment.type === 'audio'" slot="default">
          <AudioPlayer
            :src="`${BASE_PATH}${message.attachment.src}`"
            :type="message.type"
          ></AudioPlayer>
        </span>

        <!-- FILE TEMPLATE -->
        <span
          v-if="
            message.attachment &&
              message.attachment.type !== 'image' &&
              message.attachment.type !== 'audio' &&
              message.attachment.type !== 'image_url'
          "
          slot="default"
        >
          <FileCard
            :name="message.attachment.name"
            :src="message.attachment.src"
            :size="fileSize(message.attachment.size)"
            :type="message.attachment.type"
          ></FileCard>
        </span>

        <!-- DATE TEMPLATE -->
        <span slot="end" class="message-time">
          {{ format(new Date(message.date), 'HH:mm:ss') }}
        </span>
      </f7-message>
    </f7-messages>
  </f7-page>
</template>

<script>
import { format } from 'date-fns';
import { BASE_PATH } from '@/js/constants/index.js';
import fileSize from '@/js/helpers/fileSize.js';

import FileCard from '@/components/FileCard.vue';
import AudioPlayer from '@/components/AudioPlayer.vue';

export default {
  name: 'PopupHistoryView',

  components: {
    FileCard,
    AudioPlayer
  },

  props: {
    messages: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      lessonId: Number(this.$f7route.params.id),
      attachments: [],
      // voiceMessage: null,
      // recorder: null,
      // audio: null,
      // isRecord: false,
      // typing: null,
      // timerId: null,
      photoBrowserId: null
      // now: Math.trunc(new Date().getTime() / 1000),
      // selectedMessage: {
      //   id: null,
      //   text: '',
      //   info: ''
      // }
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,
    fileSize: () => fileSize,
    format: () => format,

    photos() {
      const photos = this.messages
        .filter(message => message.attachment && message.attachment.type === 'image')
        .map(message => `${BASE_PATH}${message.attachment.src}`);

      return photos;
    }
  },

  methods: {
    isFirstMessage(message, index) {
      const previousMessage = this.messages[index - 1];
      if (message.isTitle) return false;
      if (
        !previousMessage ||
        previousMessage.type !== message.type ||
        previousMessage.name !== message.name
      )
        return true;
      return false;
    },

    isLastMessage(message, index) {
      const nextMessage = this.messages[index + 1];
      if (message.isTitle) return false;
      if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name)
        return true;
      return false;
    },

    isTailMessage(message, index) {
      const nextMessage = this.messages[index + 1];
      if (message.isTitle) return false;
      if (!nextMessage || nextMessage.type !== message.type || nextMessage.name !== message.name)
        return true;
      return false;
    },

    createPhotoBrowser() {
      this.photoBrowserId = this.$f7.photoBrowser.create({
        theme: 'dark',
        photos: this.photos
      });
    },

    async openPhotoBrowser(src) {
      const index = this.photos.indexOf(`${BASE_PATH}${src}`);

      if (this.photoBrowserId) {
        this.photoBrowserId.destroy();

        await this.$nextTick();
        this.createPhotoBrowser();
        await this.$nextTick();
        this.photoBrowserId.open(index);
      } else {
        this.createPhotoBrowser();
        await this.$nextTick();
        this.photoBrowserId.open(index);
      }
    }
  }
};
</script>

<style lang="scss">
.chat.chat-history {
  .navbar-inner {
    padding: 0 calc(var(--f7-navbar-inner-padding-right) + var(--f7-safe-area-right)) 0
      calc(var(--f7-navbar-inner-padding-left) + var(--f7-safe-area-left));
  }

  .message .message-mark-icon {
    background-color: #ffffff;
  }

  .quote-messages {
    color: #000000;
    border-bottom-color: var(--f7-bars-border-color);
  }

  .quote-messages-info {
    color: #d5d8dd;
  }
}

.chat-empty-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  font-size: 16px;
  color: #87919c;
}
</style>
